/**
 * iter87.563 (user-requested — "improvement idea for captioning")
 * — shared caption for a multi-sub-pick game card (Winner / Game Ends
 * In / Total Goals, etc.). Any future predictor that reuses this
 * 3-sub-pick shape should render its group captions with this
 * component instead of copy-pasting the className, so a future style
 * tweak (e.g. the iter87.562 contrast fix) only has to land once.
 */
export const SubPickLabel = ({ children }) => (
    <p className="text-[9px] uppercase tracking-wider text-zinc-400 font-bold mb-1">{children}</p>
);
